import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import AnimatedNumber from 'animated-number-vue';
/**
 * Dashboard Base Card Header Component
 * @author Angelo Berina <angelo@gorated.ph>
 * @since v0.0.2
 */
let DashboardCardSectionHeader = class DashboardCardSectionHeader extends Vue {
    constructor() {
        super(...arguments);
        /**
         * duration for animating numbers
         */
        this.duration = 2000;
    }
    /**
     * Method for rendering styles depending on its variant
     */
    styles() {
        return {
            '--raised': this.raised,
        };
    }
    /**
     * Method as to number will be animated without decimal
     */
    animateFormatValueInteger(quantity) {
        return Math.floor(quantity);
    }
    /**
     * Method as to number will be animated with decimal
     */
    animateFormatValueFloat(subQuantity) {
        return Number(subQuantity).toFixed(2);
    }
};
__decorate([
    Prop({ type: String, default: '' })
], DashboardCardSectionHeader.prototype, "section", void 0);
__decorate([
    Prop({ type: String, default: '' })
], DashboardCardSectionHeader.prototype, "subTitle", void 0);
__decorate([
    Prop({ type: Number, default: 0.0 })
], DashboardCardSectionHeader.prototype, "quantity", void 0);
__decorate([
    Prop({ type: Number, default: 0.0 })
], DashboardCardSectionHeader.prototype, "average", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DashboardCardSectionHeader.prototype, "raised", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DashboardCardSectionHeader.prototype, "toCurrency", void 0);
__decorate([
    Prop({ type: String, default: 'text' })
], DashboardCardSectionHeader.prototype, "sectionClass", void 0);
__decorate([
    Prop({ type: String, default: 'count' })
], DashboardCardSectionHeader.prototype, "quantityClass", void 0);
DashboardCardSectionHeader = __decorate([
    Component({
        components: {
            AnimatedNumber,
        },
    })
], DashboardCardSectionHeader);
export default DashboardCardSectionHeader;
